export default "__VITE_ASSET__0p88hBe8__"